export const MARKER_DATA = [
  {
    stationcode: 10,
    title: "강릉",
    lat: 37.80434746803854,
    lng: 128.90772877206354,
  },
  {
    stationcode: 4,
    title: "대전",
    lat: 36.350685319951296,
    lng: 127.38484113756908,
  },
  {
    stationcode: 6,
    title: "부산",
    lat: 35.17989493738095,
    lng: 129.07481938748694,
  },
  {
    stationcode: 3,
    title: "목포",
    lat: 34.81175981302351,
    lng: 126.39288397125186,
  },
  {
    stationcode: 5,
    title: "제주",
    lat: 33.49946587036754,
    lng: 126.53085345505487,
  },
];
